import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function HeadofdivisionsReducer(state = initialState.headofdivisions, action: any) {
  switch (action.type) {
    case types.SAVE_HEADOFDIVISIONS_SUCCESS:
      return action.headofdivisions;
    default:
      return state;
  }
}
